import React, { Fragment } from "react";

import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import isUberAdmin from "../utils/is-uber-admin";

let credentials = JSON.parse(localStorage.getItem("credentials"));

const DrawerContent = () => (
  <Fragment>
    {(() => {
      switch (credentials.user.type) {
        case "PERSON":
          return (
            <List>
              <List subheader={<ListSubheader>Beheer</ListSubheader>}>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/company`;
                  }}
                >
                  <ListItemText primary="Bedrijven" />
                </ListItem>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/employee`;
                  }}
                >
                  <ListItemText primary="Medewerkers" />
                </ListItem>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/shifttype`;
                  }}
                >
                  <ListItemText primary="Dienstsoorten" />
                </ListItem>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/project`;
                  }}
                >
                  <ListItemText primary="Projecten" />
                </ListItem>
              </List>
              <List subheader={<ListSubheader>Overige</ListSubheader>}>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/hour_registration`;
                  }}
                >
                  <ListItemText primary="Urenregistratie" />
                </ListItem>

                {isUberAdmin && (
                  <Fragment>
                    <Divider />
                    <ListItem
                      button
                      onClick={() => {
                        window.location.href = `/hour_registration_for_invoices`;
                      }}
                    >
                      <ListItemText primary="Urenregistratie voor facturen" />
                    </ListItem>
                  </Fragment>
                )}

                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/schedule`;
                  }}
                >
                  <ListItemText primary="Rooster" />
                </ListItem>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/projects_schedule`;
                  }}
                >
                  <ListItemText primary="Rooster projecten" />
                </ListItem>

                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/shift/explore`;
                  }}
                >
                  <ListItemText primary="Bekijk dienstaanvragen" />
                </ListItem>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  <ListItemText primary="Dashboard" />
                </ListItem>
              </List>
            </List>
          );
        case "COMPANY":
          return (
            <List>
              <List subheader={<ListSubheader>Beheer</ListSubheader>}>
                <Divider />

                {credentials.user.isSecurityCompany && (
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/employee`;
                    }}
                  >
                    <ListItemText primary="Medewerkers" />
                  </ListItem>
                )}
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/project`;
                  }}
                >
                  <ListItemText primary="Projecten" />
                </ListItem>
              </List>
              <List subheader={<ListSubheader>Overige</ListSubheader>}>
                {credentials.user.isSecurityCompany && (
                  <Fragment>
                    <Divider />
                    <ListItem
                      button
                      onClick={() => {
                        window.location.href = `/hour_registration`;
                      }}
                    >
                      <ListItemText primary="Urenregistratie" />
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      onClick={() => {
                        window.location.href = `/shift/explore`;
                      }}
                    >
                      <ListItemText primary="Bekijk dienstaanvragen" />
                    </ListItem>
                  </Fragment>
                )}

                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  <ListItemText primary="Dashboard" />
                </ListItem>
              </List>
            </List>
          );
        case "EMPLOYEE":
          if (credentials.user.isSeniorEmployee) {
            return (
              <List>
                <List subheader={<ListSubheader>Beheer</ListSubheader>}>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/employee`;
                    }}
                  >
                    <ListItemText primary="Medewerkers" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/project`;
                    }}
                  >
                    <ListItemText primary="Projecten" />
                  </ListItem>
                </List>
                <List subheader={<ListSubheader>Overige</ListSubheader>}>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/schedule`;
                    }}
                  >
                    <ListItemText primary="Planning" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/hour_registration`;
                    }}
                  >
                    <ListItemText primary="Urenregistratie" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/shift/explore`;
                    }}
                  >
                    <ListItemText primary="Bekijk dienstaanvragen" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/`;
                    }}
                  >
                    <ListItemText primary="Dashboard" />
                  </ListItem>
                </List>
              </List>
            );
          } else {
            return (
              <List>
                <List subheader={<ListSubheader>Overige</ListSubheader>}>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/schedule`;
                    }}
                  >
                    <ListItemText primary="Planning" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/hour_registration`;
                    }}
                  >
                    <ListItemText primary="Urenregistratie" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => {
                      window.location.href = `/`;
                    }}
                  >
                    <ListItemText primary="Dashboard" />
                  </ListItem>
                </List>
              </List>
            );
          }

        default:
          return (
            <List>
              <List subheader={<ListSubheader>Overige</ListSubheader>}>
                <Divider />
                <ListItem
                  button
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  <ListItemText primary="Dashboard" />
                </ListItem>
              </List>
            </List>
          );
      }
    })()}
  </Fragment>
);

export default DrawerContent;



// WEBPACK FOOTER //
// ./src/components/DrawerContent.js